import url from "url";
import objectPath from "object-path";
export const getQueryParams = () => {
    // get url
    const completeUrl = window.location.search;

    // parse the url
    const parsedUrl = url.parse(completeUrl);

    // extract the query and return it as object
    // no need to decode, the job is done by the utilitary
    const query = new URLSearchParams(parsedUrl.search);
    return Array.from(query.entries());
};

export const overrideSettings = (settings, options) => {
    // get parameters from the query to override the settings as an array of array containing [key, value]
    // of the query params

    const query = options ? options : getQueryParams();

    // make any error to fail silently
    try {
        query.forEach(([key, value]) => {
            // try to parse the value. If not parsed, assumes it is a string
            // a number is parsed as a number, an object as an object, array as array but string not matching
            // JSON is not parsed
            let parsed;
            try {
                parsed = JSON.parse(value);
            } catch (error) {
                parsed = value;
            }

            // set the value at the specified path
            objectPath.set(settings, key, parsed);
        });
    } catch (error) {}
};
